import { FieldPath, FieldValues, UseControllerProps, useController } from 'react-hook-form';
import {
    ColorInputProps,
    ColorPickerDropdown,
    ColorPickerDropdownProps,
} from '@givebutter/primitives/color-picker';

interface UseFormColorPickerProps<T extends FieldValues, K extends FieldPath<T>>
    extends UseControllerProps<T, K>,
        Omit<ColorPickerDropdownProps, 'name' | 'defaultValue'> {}

const UseFormColorPicker = <T extends FieldValues, K extends FieldPath<T>>({
    control,
    name,
    defaultValue,
    rules,
    disabled,
    onValueChange,
    ...restColorPickerProps
}: UseFormColorPickerProps<T, K>) => {
    const {
        field: { onChange: onChangeInternal, onBlur, value },
    } = useController({
        name,
        control,
        defaultValue,
        rules,
        disabled,
    });

    const onControlledColorChange: ColorInputProps['onValueChange'] = color => {
        onChangeInternal(color);
        onValueChange?.(color);
    };

    return (
        <ColorPickerDropdown
            onValueChange={onControlledColorChange}
            onBlur={onBlur}
            value={value as string}
            disabled={disabled}
            {...restColorPickerProps}
        />
    );
};

export { UseFormColorPicker };
export type { UseFormColorPickerProps };
